import i18n from '../../locales/index'
import restful from '@/store/vuex'
import axios from 'axios'
import { Message } from 'view-design';

const state = {
  ...restful.states('delivery_setting')
}

const getters = {
  ...restful.getters('delivery_setting')
}

const actions = {
  ...restful.actions('delivery_settings'),
  async display ({ commit }) {
    const res = await axios.get('delivery_settings/display')
    commit('delivery_setting', res.data)
  },
  async upgrade ({ commit }, params) {
    const res = await axios.post('delivery_settings/upgrade', params)
    commit('delivery_setting', res.data)
    Message.success(i18n.t('store_modules_delivery_setting_1328'));
  },
  async geocoder ({ commit }, params) {
    const res = await axios.get('geocoder', { params, base: '/' })
    return res
  }
}

const mutations = {
  ...restful.mutations('delivery_setting'),
  delivery_setting (state, setting) {
    state.delivery_setting = setting
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
